export default function Documentation() {
    return(
        <div>Documentation</div>
    )
};
